import React, { useEffect } from "react";
import Sidebar from "./components/Sidebar";
import Container from "@material-ui/core/Container";
import clsx from "clsx";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { setToolbarPage } from "../../../Dashboard/actions/toolbar";
import { openMenuOC } from "../../../Dashboard/actions/handleOpenCloseActions";
import PVProductivity from "./routes_sidebar/PVProductivity";
import PVStorage from "./routes_sidebar/PVStorage";
import PVMonthlyBalance from "./routes_sidebar/PVMonthlyBalance";
import PVFinancials from "./routes_sidebar/PVFinancials";
import PVEnvironment from "./routes_sidebar/PVEnvironment";
import WTProductivity from "./routes_sidebar/WTProductivity";
import WTStorage from "./routes_sidebar/WTStorage";
import WTMonthlyBalance from "./routes_sidebar/WTMonthlyBalance";
import WTFinancials from "./routes_sidebar/WTFinancials";
import WTEnvironment from "./routes_sidebar/WTEnvironment";
import PVWTProductivity from "./routes_sidebar/PVWTProductivity";
import PVWTStorage from "./routes_sidebar/PVWTStorage";
import PVWTMonthlyBalance from "./routes_sidebar/PVWTMonthlyBalance";
import PVWTFinancials from "./routes_sidebar/PVWTFinancials";

export const Results = ({
  open,
  analysis,
  classes,
  setToolbarPage,
  openMenuOC,
}) => {
  useEffect(() => {
    setToolbarPage("Results");
    openMenuOC();
  }, []);
  return (
    <React.Fragment>
      <Sidebar></Sidebar>
      <main className={clsx(classes.content, !open && classes.contentShift)}>
        <div className={classes.appBarSpacer} />
        <Container
          maxWidth="xl"
          className={classes.container}
          style={{ padding: 0 }}
        >
          {analysis.id === null ? (
            <div
              style={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              Open a case to view results
            </div>
          ) : (
            <React.Fragment>
              <Route
                path="/dashboard/results/photovoltaic/productivity"
                render={(props) => <PVProductivity {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/photovoltaic/storage"
                render={(props) => <PVStorage {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/photovoltaic/monthly_balance"
                render={(props) => <PVMonthlyBalance {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/photovoltaic/financials"
                render={(props) => <PVFinancials {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/photovoltaic/environment"
                render={(props) => <PVEnvironment {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/windturbine/productivity"
                render={(props) => <WTProductivity {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/windturbine/storage"
                render={(props) => <WTStorage {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/windturbine/monthly_balance"
                render={(props) => <WTMonthlyBalance {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/windturbine/financials"
                render={(props) => <WTFinancials {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/windturbine/environment"
                render={(props) => <WTEnvironment {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/pv_wt/productivity"
                render={(props) => <PVWTProductivity {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/pv_wt/storage"
                render={(props) => <PVWTStorage {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/pv_wt/monthly_balance"
                render={(props) => <PVWTMonthlyBalance {...props} />}
              ></Route>
              <Route
                path="/dashboard/results/pv_wt/financials"
                render={(props) => <PVWTFinancials {...props} />}
              ></Route>
            </React.Fragment>
          )}
        </Container>
      </main>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  open: state.handleOpenClose.open,
  analysis: state.analysis,
});

export default connect(mapStateToProps, {
  setToolbarPage,
  openMenuOC,
})(Results);
